module.exports = __webpack_public_path__ + "img/register.8be671fa.png";